(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["unxampld-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeContactSection = (root = document) => {
      const sectionRoot = root.matches?.('.contact-page') ? root : root.querySelector?.('.contact-page');
      if (!sectionRoot || sectionRoot.dataset.contactReady === 'true') return;

      sectionRoot.dataset.contactReady = 'true';
      const form = sectionRoot.querySelector('#ContactForm');
      const fieldsContainer = sectionRoot.querySelector('[data-contact-form-fields]');
      const success = sectionRoot.querySelector('[data-contact-success]');
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

      const getMultilineCaretPosition = (field, styles) => {
        const mirror = document.createElement('div');
        const marker = document.createElement('span');
        const properties = [
          'boxSizing',
          'width',
          'borderTopWidth',
          'borderRightWidth',
          'borderBottomWidth',
          'borderLeftWidth',
          'paddingTop',
          'paddingRight',
          'paddingBottom',
          'paddingLeft',
          'fontFamily',
          'fontSize',
          'fontStyle',
          'fontWeight',
          'fontVariant',
          'lineHeight',
          'letterSpacing',
          'textAlign',
          'textIndent',
          'textTransform',
          'wordSpacing',
          'tabSize'
        ];

        properties.forEach((property) => {
          mirror.style[property] = styles[property];
        });

        mirror.style.position = 'fixed';
        mirror.style.left = '-9999px';
        mirror.style.top = '0';
        mirror.style.height = 'auto';
        mirror.style.visibility = 'hidden';
        mirror.style.whiteSpace = 'pre-wrap';
        mirror.style.overflowWrap = 'break-word';
        mirror.style.wordWrap = 'break-word';
        mirror.style.overflow = 'hidden';

        const selectionStart = field.selectionStart || 0;
        mirror.textContent = field.value.slice(0, selectionStart);
        marker.textContent = field.value.slice(selectionStart, selectionStart + 1) || '\u200b';
        mirror.appendChild(marker);
        document.body.appendChild(mirror);

        const lineHeight = Number.parseFloat(styles.lineHeight) || Number.parseFloat(styles.fontSize) * 1.2;
        const position = {
          x: marker.offsetLeft - field.scrollLeft,
          y: marker.offsetTop + lineHeight - field.scrollTop - 1
        };

        mirror.remove();
        return position;
      };

      sectionRoot.querySelectorAll('.contact-caret-field').forEach((field) => {
        const inputWrap = field.closest('.contact-caret-wrap');
        const caret = inputWrap?.querySelector('.contact-type-caret');

        const deactivateCaret = () => {
          inputWrap?.classList.remove('is-caret-active');
          if (caret) caret.hidden = true;
        };

        const activateCaret = () => {
          if (caret) caret.hidden = false;
          inputWrap?.classList.add('is-caret-active');
        };

        const updateCaret = () => {
          if (!inputWrap || !caret || !context || document.activeElement !== field) return;

          const styles = window.getComputedStyle(field);
          const borderLeft = Number.parseFloat(styles.borderLeftWidth) || 0;
          const borderRight = Number.parseFloat(styles.borderRightWidth) || 0;
          const borderTop = Number.parseFloat(styles.borderTopWidth) || 0;
          const borderBottom = Number.parseFloat(styles.borderBottomWidth) || 0;
          const paddingLeft = Number.parseFloat(styles.paddingLeft) || 0;
          const paddingRight = Number.parseFloat(styles.paddingRight) || 0;
          const paddingTop = Number.parseFloat(styles.paddingTop) || 0;
          const lineHeight = Number.parseFloat(styles.lineHeight) || Number.parseFloat(styles.fontSize) * 1.2;
          let position;

          if (field.hasAttribute('data-contact-caret-multiline')) {
            position = getMultilineCaretPosition(field, styles);
          } else {
            const text = field.value.slice(0, field.selectionStart || 0);
            const letterSpacing = Number.parseFloat(styles.letterSpacing) || 0;
            context.font = styles.font;
            const textWidth = context.measureText(text).width + Math.max(0, text.length - 1) * letterSpacing;
            position = {
              x: borderLeft + paddingLeft + textWidth - field.scrollLeft,
              y: borderTop + paddingTop + lineHeight - 1
            };
          }

          const maximumX = field.clientWidth - borderRight - paddingRight - 9;
          const maximumY = field.clientHeight - borderBottom - 2;
          const caretX = clamp(position.x, borderLeft + 2, maximumX);
          const caretY = clamp(position.y, borderTop + 2, maximumY);

          inputWrap.style.setProperty('--contact-caret-x', `${caretX}px`);
          inputWrap.style.setProperty('--contact-caret-y', `${caretY}px`);
        };

        field.dataset.contactCaretReady = 'true';
        deactivateCaret();
        field.addEventListener('pointerdown', activateCaret);
        field.addEventListener('blur', deactivateCaret);
        field.addEventListener('click', () => {
          activateCaret();
          updateCaret();
        });
        field.addEventListener('input', () => {
          field.classList.remove('error');
          field.removeAttribute('aria-invalid');
          updateCaret();
        });
        field.addEventListener('keyup', updateCaret);
        field.addEventListener('select', updateCaret);
        field.addEventListener('scroll', updateCaret, { passive: true });
        window.addEventListener('blur', deactivateCaret);
        document.addEventListener('pointerdown', (event) => {
          if (event.target !== field) deactivateCaret();
        }, true);
      });

      form?.addEventListener('submit', (event) => {
        const name = form.querySelector('[name="contact[name]"]');
        const email = form.querySelector('[name="contact[email]"]');
        const phone = form.querySelector('[name="contact[phone]"]');
        const comment = form.querySelector('[name="contact[body]"]');
        const fields = [name, email, phone, comment].filter(Boolean);
        let firstInvalid;

        fields.forEach((field) => {
          field.classList.remove('error');
          field.removeAttribute('aria-invalid');
        });

        const markInvalid = (field) => {
          field.classList.add('error');
          field.setAttribute('aria-invalid', 'true');
          if (!firstInvalid) firstInvalid = field;
        };

        if (!name?.value.trim()) markInvalid(name);
        if (!email?.value.trim() || !email.validity.valid) markInvalid(email);
        if (!phone?.value || phone.value.replace(/\D/g, '').length < 7) markInvalid(phone);
        if (!comment?.value.trim()) markInvalid(comment);

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus({ preventScroll: true });
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });

      if (success && !success.hidden && fieldsContainer) {
        window.setTimeout(() => {
          success.hidden = true;
          success.classList.remove('is-visible');
          fieldsContainer.hidden = false;
          form?.reset();
          if (window.history.replaceState) {
            window.history.replaceState({}, document.title, window.location.pathname);
          }
        }, 1100);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeContactSection(), { once: true });
    } else {
      initializeContactSection();
    }

    document.addEventListener('shopify:section:load', (event) => initializeContactSection(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unxampld-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSingleLineFields = (root = document) => {
      root.querySelectorAll('.newsletter-form .single-line-textbox:not([data-single-line-ready])').forEach((field) => {
        const inputWrap = field.closest('.newsletter-input-wrap');
        const caret = inputWrap?.querySelector('.newsletter-type-caret');
        const defaultPlaceholder = field.getAttribute('placeholder') || '';
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const updateCaret = () => {
          if (!inputWrap || !context || document.activeElement !== field) return;

          const styles = window.getComputedStyle(field);
          const text = field.value.slice(0, field.selectionStart || 0);
          const letterSpacing = Number.parseFloat(styles.letterSpacing) || 0;
          const paddingLeft = Number.parseFloat(styles.paddingLeft) || 0;
          const paddingTop = Number.parseFloat(styles.paddingTop) || 0;
          const borderLeft = Number.parseFloat(styles.borderLeftWidth) || 0;
          const borderTop = Number.parseFloat(styles.borderTopWidth) || 0;
          const borderBottom = Number.parseFloat(styles.borderBottomWidth) || 0;
          const paddingRight = Number.parseFloat(styles.paddingRight) || 0;
          const borderRight = Number.parseFloat(styles.borderRightWidth) || 0;
          const lineHeight = Number.parseFloat(styles.lineHeight) || Number.parseFloat(styles.fontSize) * 1.2;

          context.font = styles.font;
          const textWidth = context.measureText(text).width + Math.max(0, text.length - 1) * letterSpacing;
          const minimumX = borderLeft + paddingLeft;
          const maximumX = field.clientWidth - borderRight - paddingRight - 9;
          const caretX = Math.min(maximumX, Math.max(minimumX, minimumX + textWidth - field.scrollLeft));
          const maximumY = field.clientHeight - borderBottom - 2;
          const caretY = Math.min(maximumY, Math.max(borderTop + 2, borderTop + paddingTop + lineHeight - 1));

          inputWrap.style.setProperty('--newsletter-caret-x', `${caretX}px`);
          inputWrap.style.setProperty('--newsletter-caret-y', `${caretY}px`);
        };

        const deactivateCaret = () => {
          inputWrap?.classList.remove('is-caret-active');
          if (caret) caret.hidden = true;
          if (!field.value) field.placeholder = defaultPlaceholder;
        };

        const activateCaret = () => {
          field.placeholder = '';
          if (caret) caret.hidden = false;
          inputWrap?.classList.add('is-caret-active');
        };

        field.dataset.singleLineReady = 'true';
        field.dataset.customCaretReady = 'true';
        deactivateCaret();
        field.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') event.preventDefault();
        });
        field.addEventListener('input', () => {
          if (/\r|\n/.test(field.value)) {
            field.value = field.value.replace(/[\r\n]+/g, '');
          }
          updateCaret();
        });
        field.addEventListener('pointerdown', () => {
          activateCaret();
        });
        field.addEventListener('blur', deactivateCaret);
        field.addEventListener('click', () => {
          activateCaret();
          updateCaret();
        });
        field.addEventListener('keyup', updateCaret);
        field.addEventListener('select', updateCaret);
        field.addEventListener('scroll', updateCaret, { passive: true });
        window.addEventListener('blur', deactivateCaret);
        document.addEventListener('pointerdown', (event) => {
          if (event.target !== field) deactivateCaret();
        }, true);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeSingleLineFields(), { once: true });
    } else {
      initializeSingleLineFields();
    }

    document.addEventListener('shopify:section:load', (event) => initializeSingleLineFields(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
